import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import 'react-tabs/style/react-tabs.css';
import DoughnutStatusChart from "../Charts/DoughnutStatusChart"
import LineEqualizationChart from "../Charts/LineEqualizationChart"


import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

//https://www.jqueryscript.net/demo/Drawing-A-Simple-Horizontal-Timeline-with-jQuery-SVG-timeframe-js/
//import Timeframe from '../TimeLine/timeframe';


import StatusResultTable from '../Results/StatusResultTable';
import CostResultTable from '../Results/CostResultTable';
import PaymentResultTable from '../Results/PaymentResultTable';
import PrincipalResultTable from '../Results/PrincipalResultTable';
import PrincipalResultBondEqualizationTable from '../Results/PrincipalResultBondEqualizationTable';
import PrincipalResultBondTable from '../Results/PrincipalResultBondTable';
import PrincipalResultBondIndexedTable from '../Results/PrincipalResultBondIndexedTable';

import ReturnStatusResultTable from '../Results/ReturnStatusResultTable';
import CancellationResultTable from '../Results/CancellationResultTable';
import ReturnResultTable from '../Results/ReturnResultTable';

import CapitalInfo from '../Results/CapitalInfo';


import Amount from 'components/Display/Amount';


class MainResultTab extends React.Component {
  state = {
    mainTabSelected : 0
  };

  constructor(props){
    super(props);
  }

  componentDidMount(){
  
  }

  isBond(setting){
    return (setting.isBond && (setting.legs != null))
  }

  isIndexed(setting){
    return (setting.isBond && (setting.legs != null) && (setting.legs[0].indexInterestDate != null) && (setting.legs[0].indexTable != null));
  }

  isEqualization(setting){    
    return (setting.isBond && (setting.legs != null) && (setting.legs[0].indexInterestDate != null) && (setting.legs[0].indexTable != null) && (setting.legs[0].isEqualization));
  }

  render() {

    
    let claimData = this.props.claimData;
    let result = this.props.result;

    const marginStyle = 
    {
      margin: '5px'
    };

   
   
    let displayPrincipalTable = (<PrincipalResultTable data={result}/> );
    if (this.isEqualization(claimData)){
      console.debug("PrincipalResultBondEqualizationTable");
      displayPrincipalTable = (<PrincipalResultBondEqualizationTable data={result}/> );
    }
    else if (this.isIndexed(claimData)){
      console.debug("PrincipalResultBondIndexedTable");
      displayPrincipalTable = (<PrincipalResultBondIndexedTable data={result}/> );
    }
    else if (this.isBond(claimData)){
      console.debug("PrincipalResultBondTable");
      displayPrincipalTable = (<PrincipalResultBondTable data={result}/> );
    }


    


   
    // var starWarsFilms = {      
    //     name: "Star Wars Films",      
    //     color: "#000000",      
    //     events: [
    //       {    
    //         name: "A New Hope", 
    //         date: "1977-05-25" 
    //       },  
    //       {    
    //         name: "The Empire Strikes Back",      
    //         date: "1980-05-21"      
    //       },      
    //       {      
    //         name: "Return of the Jedi",      
    //         date: "1983-05-25"      
    //       }    
    //     ]      
    //   };
      
    //   var t = Timeframe("#timeframe")
    //   .addCategory(starWarsFilms)      
    //     .start("1975-01-01")      
    //     .end("1985-01-01")      
    //     .draw();
      

    return (      
      <div className="grid tight">
        <div className="col s3of12">            
          <StatusResultTable data={result}/><br/>
        </div>  
        <div className="col s9of12">
          <Tabs selectedIndex={this.state.mainTabSelected} onSelect={index =>  this.setState({mainTabSelected : index}) }>
            <TabList>
              <Tab>Skil</Tab>                
              <Tab>Kostnaður</Tab>
              <Tab>Innborganir</Tab>              
            </TabList>
            <TabPanel>
              <div className="grid">
                <div className="col s5of12" style={marginStyle} >
                  <ReturnStatusResultTable data={result}/>
                </div>
                <div className="col s4of12" style={marginStyle}>
                  <CancellationResultTable data={result}/>
                </div>
                <div className="col s2of12" style={marginStyle}>
                  <ReturnResultTable data={result}/>  
                </div>
              </div>        
            </TabPanel>   
            <TabPanel>
              <div className="grid">
                <div className="col s10of12">
                  <CostResultTable data={result}/> <br/>                             
                </div>
              </div>        
            </TabPanel>              
            <TabPanel>
              <div className="grid">
                <div className="col s10of12">
                  <PaymentResultTable data={result}/>                    
                </div>
              </div>        
            </TabPanel>                          
            
          </Tabs>
        </div>
        <h1>Höfuðstólar</h1>
        <line/>
        <div className="grid tight">
          <div className="col s3of12">
              <DoughnutStatusChart result={result} />
              {/* <br/>
              <div id="timeframe"></div> */}
          </div>
          <div className="col s9of12">
            <CapitalInfo data={result} setting={claimData}/>
          </div>
          <div className="col s3of12">
            <LineEqualizationChart result={result}/>>
          </div>
        </div>


        <div className="grid tight">
          <div className="col s12of12">            
            {displayPrincipalTable}   
          </div>  
        </div>

      </div>    
    );
  }
}

MainResultTab.propTypes = {
  claimData : PropTypes.object, 
  result : PropTypes.object, 
};



export default MainResultTab;




// WEBPACK FOOTER //
// ./src/pages/Calculation/Tabs/MainResultTab.js